module.exports = __webpack_public_path__ + "img/banner-disclaimer.c243d7e2.jpg";